module.exports = "<div class=\"gmc-card mail-body\"><gmc-local-spinner ng-if=$ctrl.loading></gmc-local-spinner><div class=body-content ng-if=\"!$ctrl.loading && $ctrl.mail\" ng-bind-html=$ctrl.trustedHtml></div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/states/mailbox/components/mail-body/mail-body.component.html
// module id = 899
// module chunks = 31